/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { createFineStructure } from '../../factoriesAny.js';
export var fineStructureDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  createFineStructure: createFineStructure
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesFineStructure.generated.js
// module id = 1548
// module chunks = 0